import React, { useEffect } from 'react';
import CloseImage from '../../assets/ic_close.png';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, Typography, withStyles } from "@material-ui/core";
import { TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InputLabel from '@material-ui/core/InputLabel';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import api from '../api';
import line from '../../assets/line grey.png';
import { setISODay } from 'date-fns';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function EditJadwalFasilitas(props) {
    console.log(props);
    const classes = useStyles()
    const efDate = props.efDate
    const day = props.detail[0]
    const timeStart = props.detail[1].slice(0, 5)
    const timeEnd = props.detail[2].slice(0, 5)
    console.log(efDate);
    // let detail = props.detail;
    // let { speciality, schedule } = detail
    const [hari, setHari] = React.useState(day)
    const [time_start, set_time_start] = React.useState(new Date(`${efDate} ${timeStart}`))
    const [time_end, set_time_end] = React.useState(new Date(`${efDate} ${timeEnd}`))

    const listHari = [
        { name: "Senin", id: 1 },
        { name: "Selasa", id: 2 },
        { name: "Rabu", id: 3 },
        { name: "Kamis", id: 4 },
        { name: "Jum'at", id: 5 },
        { name: "Sabtu", id: 6 },
        { name: "Minggu", id: 7 },
    ]

    React.useEffect(() => {
        if (day) {
            let indexHari = listHari.findIndex((val) => val.name === props.detail[0])
            setHari(listHari[indexHari])
        }
    }, [])

    console.log(time_start);

    const handleEdit = () => {
        console.log(time_start);
        console.log(hari);
        console.log(time_end);
        let schedule = [
            {
                "day_id": hari.id,
                "session": [
                    {
                        "time_start": time_start,
                        "time_end": time_end
                    }
                ]
            }
        ]
        let payload = {
            "id": props.detail[5],
            "time_start": `${new Date(time_start).getHours() < 10 ? `0${new Date(time_start).getHours()}` : new Date(time_start).getHours()}:${new Date(time_start).getMinutes() < 10 ? `0${new Date(time_start).getMinutes()}` : new Date(time_start).getMinutes()}`,
            "time_end": `${new Date(time_end).getHours() < 10 ? `0${new Date(time_end).getHours()}` : new Date(time_end).getHours()}:${new Date(time_end).getMinutes() < 10 ? `0${new Date(time_end).getMinutes()}` : new Date(time_end).getMinutes()}`,
            "day_id": hari.id
        }
        console.log(payload);
        api.create().updateScheduleFacility(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    props.refresh()
                    props.onClose(false)
                }
            }
        })
    }
    
    const forceUpdate = React.useReducer(bool => !bool)[1];

    return (
        <div className="App app-popup-show">
            {
                    props.isEdit === true ?
                        <div className="popup-content background-white" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18, }}>Edit Master Jadwal Fasilitas</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => props.onClose()}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50}}>
                                <div className="column-1"  style={{width: '90%'}}>
                                    <div className="">
                                        <TextField
                                            style={{ width: '100%' }}
                                            id="efDate"
                                            label="Effective Date"
                                            disabled
                                            // id="outlined-read-only-input"
                                            variant="filled"
                                            value={efDate}
                                            onChange={(e) => null}
                                            inputProps={{
                                                style: {
                                                    fontSize: 14,
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                        >
                                        </TextField>
                                    </div>
                                    <div className="">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                style={{width: "100%", marginTop: 30, marginTop: 36}}
                                                margin="normal"
                                                id="jamMulai"
                                                clearLabel
                                                ampm={false}
                                                label="Jam Mulai"
                                                value={time_start}
                                                onChange={(date) => set_time_start(date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                </div>
                                <div className="column-2"  style={{width: '90%', marginLeft: 25}}>
                                    <div className="" style={{padding: 9, marginTop: -8}}>
                                        <FormControl style={{ width: '100%' }}>
                                            <Autocomplete
                                                // multiple
                                                style={{marginTop: 8, width: '100%'}}
                                                options={listHari}
                                                debug
                                                getOptionLabel={(option) => option.name}
                                                debug
                                                name='hari'
                                                id="hari"
                                                value={hari}
                                                onChange={(event, newInputValue) => {
                                                    setHari(newInputValue)
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                                        label="Hari"
                                                    />
                                                }
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="" style={{marginLeft: 7, marginTop: 1}}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                style={{width: "100%", marginTop: 30, marginTop: 27}}
                                                margin="normal"
                                                id="jamMulai"
                                                clearLabel
                                                ampm={false}
                                                label="Jam Selesai"
                                                value={time_end}
                                                onChange={(date) => set_time_end(date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                </div>
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div onClick={(e) => handleEdit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="popup-content background-white" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18, }}>Detail Master Jadwal Fasilitas</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => props.onClose()}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div className="grid grid-2x" style={{ padding: 20, paddingRight: 50, paddingLeft: 50}}>
                                <div className="column-1" style={{width: '90%'}}>
                                    <div className="">
                                        <TextField
                                            style={{ width: '100%' }}
                                            id="efDate"
                                            label="Effective Date"
                                            disabled
                                            // id="outlined-read-only-input"
                                            variant="filled"
                                            value={efDate}
                                            onChange={(e) => null}
                                            inputProps={{
                                                style: {
                                                    fontSize: 14,
                                                }
                                            }}
                                            InputLabelProps={{
                                                style: {
                                                    fontSize: 14,
                                                    color: '#7e8085',
                                                }
                                            }}
                                            disabled
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                        >
                                        </TextField>
                                    </div>
                                    <div className="">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                style={{width: "100%", marginTop: 30, marginTop: 36}}
                                                margin="normal"
                                                id="jamMulai"
                                                clearLabel
                                                ampm={false}
                                                label="Jam Mulai"
                                                value={time_start}
                                                onChange={(date) => set_time_start(date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                                disabled
                                                InputProps={{
                                                    disableUnderline: true
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                        <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                    </div>
                                </div>
                                <div className="column-2" style={{width: '90%', marginLeft: 25}}>
                                    <div className="" style={{padding: 9, marginTop: -8}}>
                                        <FormControl style={{ width: '100%' }}>
                                            <Autocomplete
                                                // multiple
                                                style={{marginTop: 8, width: '100%'}}
                                                options={listHari}
                                                debug
                                                getOptionLabel={(option) => option.name}
                                                debug
                                                disabled
                                                name='hari'
                                                id="hari"
                                                value={hari}
                                                onChange={(event, newInputValue) => {
                                                    setHari(newInputValue)
                                                }}
                                                renderInput={(params) =>
                                                    <TextField
                                                        {...params}
                                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 }, disableUnderline: true }}
                                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                                        label="Hari"
                                                    />
                                                }
                                            />
                                        </FormControl>
                                        <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                    </div>
                                    <div className="" style={{marginLeft: 7}}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                style={{width: "100%", marginTop: 7}}
                                                margin="normal"
                                                id="jamMulai"
                                                clearLabel
                                                ampm={false}
                                                label="Jam Selesai"
                                                value={time_end}
                                                onChange={(date) => set_time_end(date)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change time',
                                                }}
                                                disabled
                                                InputProps={{
                                                    disableUnderline: true
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                        <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                    </div>
                                </div>
                            </div>
                            <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                <div className="column-1" style={{ alignSelf: 'center' }}>
                                </div>
                                <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                    {/* <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div> */}
                                    <div onClick={(e) => props.onClose()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Kembali</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
            }
        </div>
    )
}